import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Product from '@/models/v5/product';

    var ProductsCollection = new v5_Collection();
    _.extend(ProductsCollection, {
        url: function() {
            return Api.urls.products();
        },
        model: Product,
        create: function(model, options) {
            options = options || {};
            var no_relationships_specified = !options.owner;
            if (no_relationships_specified) {
                throw new Error('Must pass an \'owner\' in the options to create a new Product');
            }
            /*
             * Two ways to pass the owner: 
             *   (1) as a raw resource object:
             *       {
             *         id: <uuid>,
             *         type: 'account'
             *       }
             *       OR
             *   (2) as an Account object with a toJSON method
             */
            var data = {
                type: 'product',
                attributes: model,
                relationships: {
                    owner: _.pick(options.owner, 'id', 'type')
                }
            };

            v5_Collection.prototype.create.call(this, data, options);
        }
    });
    export default ProductsCollection;

